import { isElementInViewport } from 'JBPlugin/in-viewport';

jQuery($ => {
	if ($('.shuffle-gallery__images').length) {
		$('.shuffle-gallery__images').each(function() {
			var self = $(this);
			let galleryContentSplitInView = function() {
				if (isElementInViewport(self)) {
					self.addClass('in-view');
				}
			};
			window.addEventListener('resize', galleryContentSplitInView);
			window.addEventListener('scroll', _.throttle(galleryContentSplitInView, 500));
		});
	}
});
